import React from 'react'
import PropTypes from 'prop-types'
import * as ctaTypes from './types'
import { withCookieConsent } from 'LiveBoard/hocs'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const CTA_COMPONENTS = {
  email: ctaTypes.GetVisitorEmailContainer,
  inline: ctaTypes.OpenLinkContainer,
  new_tab: ctaTypes.OpenLinkContainer,
  form: ctaTypes.ConfigurableFormDialog,
  message: ctaTypes.SendMessageContainer,
  share: ctaTypes.ShareBoardContainer,
  registration: ctaTypes.ConfigurableFormDialog
}

class CallToAction extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isCtaDisplayed: false }
  }

  componentDidMount() {
    this.props.autoOpenOnRender && this.handleCtaClick()
  }

  componentWillUnmount() {
    this.state.isCtaDisplayed && this.props.onClose()
  }

  handleCtaClick = (e) => {
    e && e.stopPropagation()
    this.setState({ isCtaDisplayed: true })
    !this.props.autoOpenOnRender && this.props.onCookieConsent()
    this.props.onClick()
  }

  handleCtaClose = (e) => {
    e && e.stopPropagation()
    this.setState({ isCtaDisplayed: false })
    this.props.onClose()
  }

  renderDefaultButton = () => {
    const { config, autoOpenOnRender, themeColorHex } = this.props
    const ctaButtonStyle = { backgroundColor: themeColorHex, borderColor: themeColorHex }
    return (
      <div>
        <span
          style={ctaButtonStyle}
          className={`cta-button-background ${config.transparent ? 'transparent' : ''}`} />
        { !autoOpenOnRender && <label>{config.text}</label> }
      </div>
    )
  }

  renderCustomButton = () => {
    return !!this.props.renderCustomButton ?
      this.props.renderCustomButton(this.handleCtaClick) : null
  }

  render() {
    const { area, config, themeColorHex, itemId, onCancel, ctaClass, renderCustomButton } = this.props
    const SpecificCTA = CTA_COMPONENTS[config.type]
    const buttonClass = !!renderCustomButton ? 'custom-cta-btn' : 'cta-button'

    return (
      <div
        className={`${buttonClass} ${ACCESSIBILITY_CLASSES.main}`}
        onClick={this.handleCtaClick}
        onKeyDown={triggerClickOnEnter}
        tabIndex={0}
        role="button"
        aria-label={`open ${config.type}`}
      >
        { this.renderCustomButton() || this.renderDefaultButton() }
        { this.state.isCtaDisplayed &&
          <SpecificCTA
            area={area}
            config={config}
            themeColorHex={themeColorHex}
            onDone={this.handleCtaClose}
            onCancel={onCancel}
            itemId={itemId}
            ctaClass={ctaClass}
            modalClass={this.props.modalClass} />
        }
      </div>
    )
  }
}

CallToAction.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  autoOpenOnRender: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onCookieConsent: PropTypes.func.isRequired,
  itemId: PropTypes.number,
  ctaClass: PropTypes.string,
  modalClass: PropTypes.string,
  renderCustomButton: PropTypes.func
}

CallToAction.defaultProps = {
  autoOpenOnRender: false
}

export default withCookieConsent(CallToAction)
